<script>
import Checkbox from '@/components/Checkbox'
import TimePicker from '@/components/TimePicker'

export default
{
    name: 'scheduled-publishing-time-picker',

    props:
    {
        // bound to v-model.
        value: { default: '' },
        show: { default: true },
    },

    created ()
    {
        if (this.value) this.scheduledPublishingDate = new Date(this.value)
    },

    render () 
    {
        return (
            <div class='scheduled-publishing-time-picker' v-show={this.show}>
                <checkbox label={this.scheduledPublishingDatePickerLabel} v-model={this.isScheduledPublishing} on-click={v => v && this.$refs.scheduledPublishingDatePicker.pick()} />
                <time-picker show={false} v-model={this.scheduledPublishingDate} format='DD-MM HH:mm YYYY' ref='scheduledPublishingDatePicker' />
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            isScheduledPublishing: false,
            scheduledPublishingDate: null,
        }
    },

    watch:
    {
        value (newVal, oldVal)
        {
            if ((newVal || '').toString() == (oldVal || '').toString()) return;
            
            this.scheduledPublishingDate = new Date(newVal)
        },

        isScheduledPublishing (newVal, oldVal)
        {
            if (newVal == oldVal) return;

            this.$emit('input', newVal ? this.scheduledPublishingDate : null)
        },

        scheduledPublishingDate (newVal, oldVal)
        {
            if ((newVal || '').toString() == (oldVal || '').toString()) return;

            if (this.scheduledPublishingDate && this.scheduledPublishingDate.toString() == new Date(undefined).toString()) this.scheduledPublishingDate = null
            if (this.scheduledPublishingDate && this.scheduledPublishingDate.toString() == new Date(0).toString()) this.scheduledPublishingDate = null

            this.$emit('input', this.scheduledPublishingDate)

            this.isScheduledPublishing = !!this.scheduledPublishingDate
        },
    },

    computed:
    {
        scheduledPublishingDatePickerLabel ()
        {
            this.scheduledPublishingDate
            return 'Publication programmée' + 
                (this.isScheduledPublishing && this.scheduledPublishingDate
                    ? ' pour le ' + new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', hour: 'numeric', minute: 'numeric', year: 'numeric' }).format(this.scheduledPublishingDate) : '')
        },
    },

    methods:
    {
    },

    components:
    {
        Checkbox,
        TimePicker
    }
}
</script>

<style lang='less'>
.scheduled-publishing-time-picker
{
    font-size: 13px;
    
    .checkbox
    {
        font-size: inherit;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduledPublishingTimePicker.vue